import { authenticatedAxios } from './axios';
import getVehicleSummariesQuery, {
  type VehicleSummariesResponse
} from './GraphQL/queries/getVehicleSummaries';
import { customerReportVehicleOutcomeMutation } from './GraphQL/mutations/selfReport';

const endpoint = `${process.env.CARVANA_APP_BFF_API}/graphql/`;

const AppraisalBffApi = {
  getSummaries: async () => {
    const response = await authenticatedAxios.post<VehicleSummariesResponse>(endpoint, {
      query: getVehicleSummariesQuery,
      variables: {}
    });
    response?.data?.errors?.forEach(error => {
      throw error;
    });
    return response.data.data;
  },

  customerReportVehicleOutcome: async (
    acquisitionName: string,
    outcome: 'MarkedSold' | 'MarkedRemoved'
  ) => {
    const response = await authenticatedAxios.post(endpoint, {
      query: customerReportVehicleOutcomeMutation,
      variables: { input: { acquisitionName, outcome } }
    });
    response?.data?.errors?.forEach((error: unknown) => {
      throw error;
    });
    return response.data.data;
  }
};

export default AppraisalBffApi;
